import React, { useState, useEffect } from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

const BarChart = (props) => {
  const { labels, dataSetOne, dataSetTwo } = props;

  const options = {
    scales: {
      y: {
        title: { display: true, text: "Count" },
      },
      x: {
        title: {
          display: true,
          text: "Time",
        },
      },
    },
    indexAxis: "x",
    elements: {
      bar: {
        borderWidth: 2,
      },
    },
    responsive: true,
    plugins: {
      legend: {
        position: "right",
      },
      title: {
        display: true,
        text: "Hourly Average",
      },
    },
  };

  const data = {
    labels,
    datasets: [
      {
        label: "Manned Count",
        data: dataSetOne,
        borderColor: "#226BF6",
        backgroundColor: "#226BF6",
      },
      {
        label: "UnManned Count",
        data: dataSetTwo,
        borderColor: "#EE4143",
        backgroundColor: "#EE4143",
      },
    ],
  };

  return <Bar height={50} width={180} options={options} data={data} />;
};

export default BarChart;
